'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = mixin;
/**
 * Mixin decorator.
 * @function mixin
 *
 * @license {@link https://opensource.org/licenses/MIT|MIT}
 *
 * @author Patrick Heng <hengpatrick.pro@gmail.com>
 * @author Fabien Motte <contact@fabienmotte.com>
 *
 * @param {...Object} mixins Mixin(s).
 *
 * @throws {SyntaxError} Mixin decorator requires at least one mixin.
 *
 * @returns {function} Wrapped target class.
 */
function mixin() {
  for (var _len = arguments.length, mixins = Array(_len), _key = 0; _key < _len; _key++) {
    mixins[_key] = arguments[_key];
  }

  if (typeof mixins[0] === 'function') {
    throw new SyntaxError('@mixin decorator \'' + mixins[0].name + '\' requires at least one mixin');
  }

  // Return wrapped target class
  return function (_ref) {
    var prototype = _ref.prototype;

    var mergedFunctions = {};

    // Parse mixins

    for (var i = 0, l = mixins.length; i < l; i++) {
      var _mixin = mixins[i];
      for (var key in _mixin) {
        var prop = _mixin[key];

        if (typeof prop === 'function') {
          mergedFunctions[key] = mergedFunctions[key] || [];
          mergedFunctions[key].push(prop);
        } else {
          prototype[key] = prop;
        }
      }
    }

    // Rewrite prototype function

    var _loop = function _loop(_key2) {
      var functions = mergedFunctions[_key2];
      var defaultFn = prototype[_key2];

      prototype[_key2] = function () {
        var result = void 0;

        for (var _len2 = arguments.length, args = Array(_len2), _key3 = 0; _key3 < _len2; _key3++) {
          args[_key3] = arguments[_key3];
        }

        for (var _i = 0, _l = functions.length; _i < _l; _i++) {
          var fn = functions[_i];
          result = fn.apply(this, args);
        }

        if (typeof defaultFn === 'function') {
          result = defaultFn.apply(this, args);
        }

        return result;
      };
    };

    for (var _key2 in mergedFunctions) {
      _loop(_key2);
    }
  };
}
module.exports = exports['default'];